export default __webpack_public_path__ + "static/media/qash.937f2a50.svg";